export const arrivalTimes = {
  supportsTimeslots: true,
  timeSlots: [
    {
      startTime: '09:00:00',
      endTime: '12:00:00',
      price: {
        amount: 7500,
        currencyCode: 'gbp',
      },
      quantity: 10,
      durationMinutes: 60,
    },
    {
      startTime: '12:00:00',
      endTime: '15:00:00',
      price: {
        amount: 7500,
        currencyCode: 'gbp',
      },
      quantity: 10,
      durationMinutes: 60,
    },
  ],
};
